import { useShipmentsPanelContext } from '../side-panel/shipments/shipments-panel-context-provider';
import { useReturnsPanelContext } from '../side-panel/returns/returns-panel-context-provider';

export const useGetShipmentandReturnCount = () => {
  const fulfillmentPlans = useShipmentsPanelContext();
  const { standardReturns: returnFulfillments, enhancedReturns } = useReturnsPanelContext();
  const returnCount = (returnFulfillments.length || 0) + (enhancedReturns.length || 0);

  return {
    shipmentCount: fulfillmentPlans.length || 0,
    returnCount,
  };
};

export const getCountText = (shipmentCount, returnCount) => {
  return {
    shipmentCountInformation: {
      count: shipmentCount,
      isOverflow: shipmentCount > 999,
    },
    returnCountInformation: {
      count: returnCount,
      isOverflow: returnCount > 999,
    },
  };
};
